import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import { LOGO_URL } from '../mock';
import { LogIn } from 'lucide-react';
import { toast } from 'sonner';

export default function Login() {
  const { login } = useApp();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (!r.ok) toast.error(r.error || 'Login failed');
    else toast.success('Welcome back');
  };

  return (
    <div className="whip-bg min-h-screen flex flex-col items-center justify-center px-4">
      <div className="flex flex-col items-center mb-8">
        <img src={LOGO_URL} alt="Whiplash Film & Creative" className="h-16 mb-3" />
        <div className="text-[11px] tracking-[0.35em] text-neutral-500 uppercase">Gear Inventory</div>
      </div>

      <div className="w-full max-w-md surface rounded-lg p-7 shadow-2xl">
        <h1 className="text-2xl font-bold text-white mb-1">Welcome back</h1>
        <p className="text-sm text-neutral-400 mb-6">Sign in to manage your gear inventory.</p>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-[11px] tracking-wider uppercase text-neutral-400 mb-1.5">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@whiplash.com"
              autoFocus
              required
              autoComplete="email"
              className="w-full bg-neutral-950 border border-neutral-800 text-white rounded-md px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500/60 focus:border-amber-500 transition-colors"
            />
          </div>
          <div>
            <label className="block text-[11px] tracking-wider uppercase text-neutral-400 mb-1.5">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              autoComplete="current-password"
              className="w-full bg-neutral-950 border border-neutral-800 text-white rounded-md px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500/60 focus:border-amber-500 transition-colors"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="btn-amber w-full rounded-md py-2.5 text-sm flex items-center justify-center gap-2 disabled:opacity-60"
          >
            <LogIn size={16} />
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
      <div className="mt-6 text-xs text-neutral-600">Whiplash Film & Creative · Gear Inventory</div>
    </div>
  );
}
